import {gql} from '@apollo/client';

export const UPDATE_USER_TRADE = gql`
  mutation UpdateTrade($tradeId: ID!, $input: UpdateTradeInput!) {
    updateTrade(tradeId: $tradeId, input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on Trade {
        id
        paymentMethod
      }
    }
  }
`;

export const DELETE_TRADE = gql`
  mutation DeleteTrade($tradeId: String!) {
    deleteTrade(tradeId: $tradeId) {
      ... on Error {
        message
        statusCode
      }
      ... on Trade {
        id
        paymentMethod
        transactionUnits
      }
    }
  }
`;

export const VOID_TRADE = gql`
  mutation VoidTrade($tradeId: ID!) {
    voidTrade(tradeId: $tradeId) {
      ... on Error {
        statusCode
        message
      }
      ... on Trade {
        id
      }
    }
  }
`;

export const CANCEL_TRADE = gql`
  mutation DeleteTrade($tradeId: String!) {
    deleteTrade(tradeId: $tradeId) {
      ... on Error {
        statusCode
        message
      }
      ... on Trade {
        userId
      }
    }
  }
`;

// Every order mutation returns the RespondWithOrder union, whose success
// members are both `Response` and `ResponseWithOrder` — which one comes back
// varies per resolver, so each document selects both. Selecting only `Response`
// (as the bond documents used to) yields a match with no `message` on the
// resolvers that answer with ResponseWithOrder, and a blank success toast.
export const BUY_PUBLIC_EQUITY = gql`
  mutation BuyPublicEquity($input: StockOrderInput!) {
    buyPublicEquity(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on Response {
        message
      }
      ... on ResponseWithOrder {
        message
      }
    }
  }
`;

export const SELL_PUBLIC_EQUITY = gql`
  mutation SellPublicEquity($input: StockOrderInput!) {
    sellPublicEquity(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on Response {
        message
      }
      ... on ResponseWithOrder {
        message
      }
    }
  }
`;

// IPOs are subscribed to, never sold back — there is no sellIPO resolver, and
// no simulator counterpart either, so the menu hides this one in Sim Mode.
export const BUY_IPO = gql`
  mutation BuyIPO($input: StockOrderInput!) {
    buyIPO(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on Response {
        message
      }
      ... on ResponseWithOrder {
        message
      }
    }
  }
`;

export const BUY_MUTUAL_FUND = gql`
  mutation BuyMutualFund($input: MutualFundOrderInput!) {
    buyMutualFund(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on Response {
        message
      }
      ... on ResponseWithOrder {
        message
      }
    }
  }
`;

export const SELL_MUTUAL_FUND = gql`
  mutation SellMutualFund($input: MutualFundOrderInput!) {
    sellMutualFund(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on Response {
        message
      }
      ... on ResponseWithOrder {
        message
      }
    }
  }
`;

export const BUY_BOND = gql`
  mutation BuyBond($input: BondOrderInput!) {
    buyBond(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on Response {
        message
      }
      ... on ResponseWithOrder {
        message
      }
    }
  }
`;

export const SELL_BOND = gql`
  mutation SellBond($input: BondOrderInput!) {
    sellBond(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on Response {
        message
      }
      ... on ResponseWithOrder {
        message
      }
    }
  }
`;

export const BUY_SIM_STOCK = gql`
  mutation BuySimStock($input: StockOrderInput!) {
    buySimStock(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on Response {
        message
      }
      ... on ResponseWithOrder {
        message
      }
    }
  }
`;

export const SELL_SIM_STOCK = gql`
  mutation SellSimStock($input: StockOrderInput!) {
    sellSimStock(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on Response {
        message
      }
      ... on ResponseWithOrder {
        message
      }
    }
  }
`;

export const BUY_SIM_BOND = gql`
  mutation BuySimBond($input: BondOrderInput!) {
    buySimBond(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on Response {
        message
      }
      ... on ResponseWithOrder {
        message
      }
    }
  }
`;

export const SELL_SIM_BOND = gql`
  mutation SellSimBond($input: BondOrderInput!) {
    sellSimBond(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on Response {
        message
      }
      ... on ResponseWithOrder {
        message
      }
    }
  }
`;

export const BUY_SIM_MUTUAL_FUND = gql`
  mutation BuySimMutualFund($input: MutualFundOrderInput!) {
    buySimMutualFund(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on Response {
        message
      }
      ... on ResponseWithOrder {
        message
      }
    }
  }
`;

export const SELL_SIM_MUTUAL_FUND = gql`
  mutation SellSimMutualFund($input: MutualFundOrderInput!) {
    sellSimMutualFund(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on Response {
        message
      }
      ... on ResponseWithOrder {
        message
      }
    }
  }
`;
